import Enum from "../../../enums/Enum";

const EnumNoteState = new Enum({
    OPEN: "Open",
    DONE: "Done"
});

export default EnumNoteState;